import React, { useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Inline SVG icons — Feather-style line art (matches Gmail.jsx + sidebar standard).
const Icon = ({ d, paths }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    {paths ? paths.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
  </svg>
);
const IconHardDrive = () => <Icon paths={["M22 12H2","M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z","M6 16h.01","M10 16h.01"]} />;
const IconUsers     = () => <Icon paths={["M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2","M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z","M23 21v-2a4 4 0 0 0-3-3.87","M16 3.13a4 4 0 0 1 0 7.75"]} />;
const IconShare     = () => <Icon paths={["M16 6l-4-4-4 4","M12 2v13","M3 15v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4"]} />;
const IconPlus      = () => <Icon paths={["M12 5v14","M5 12h14"]} />;
const IconFolder    = () => <Icon d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />;
const IconFile      = () => <Icon paths={["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z","M14 2v6h6"]} />;
const IconFileText  = () => <Icon paths={["M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z","M14 2v6h6","M16 13H8","M16 17H8","M10 9H8"]} />;
const IconImage     = () => <Icon paths={["M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z","M8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","M21 15l-5-5L5 21"]} />;
const IconChevRight = () => <Icon d="M9 18l6-6-6-6" />;
const IconExternal  = () => <Icon paths={["M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6","M15 3h6v6","M10 14L21 3"]} />;
const IconKebab     = () => <Icon paths={["M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","M12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","M12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"]} />;
const IconDownload  = () => <Icon paths={["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4","M7 10l5 5 5-5","M12 15V3"]} />;
const IconTrash     = () => <Icon paths={["M3 6h18","M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2","M10 11v6","M14 11v6"]} />;
const IconEdit      = () => <Icon paths={["M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7","M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"]} />;
const IconFolderPlus = () => <Icon paths={["M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z","M12 11v6","M9 14h6"]} />;
const IconUpload    = () => <Icon paths={["M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4","M17 8l-5-5-5 5","M12 3v12"]} />;
const IconSearch    = () => <Icon paths={["M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z","M21 21l-4.35-4.35"]} />;
const IconCloseSm   = () => <Icon paths={["M18 6 6 18","M6 6l12 12"]} />;

export default function GoogleDriveHub() {
  const [connected, setConnected] = useState(null);
  const [view, setView]           = useState({ type: 'my-drive', folderId: 'root', driveId: null });
  const [drives, setDrives]       = useState([]);   // shared drives list
  const [drivesLoading, setDrivesLoading] = useState(false);
  const [files, setFiles]         = useState([]);
  const [filesLoading, setFilesLoading] = useState(false);
  const [filesError, setFilesError]   = useState(null);
  const [crumbs, setCrumbs]       = useState([{ id: 'root', name: 'My Drive' }]);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [menuOpenForId, setMenuOpenForId] = useState(null);    // which file's kebab menu is open
  const [renameTarget, setRenameTarget]   = useState(null);    // {id, name} being renamed
  const [renameValue, setRenameValue]     = useState('');
  const [renameBusy, setRenameBusy]       = useState(false);
  const [newMenuOpen, setNewMenuOpen]     = useState(false);
  const [newFolderOpen, setNewFolderOpen] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [newFolderBusy, setNewFolderBusy] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(null); // { current, total, filename } or null
  const [dragActive, setDragActive]       = useState(false);
  const [searchDraft, setSearchDraft]     = useState('');   // what's typed in the search box
  const [searchQuery, setSearchQuery]     = useState('');   // active search (committed on Enter), '' = no search
  // Sidebar folder tree: My Drive and each shared drive expand to show their subfolders.
  const [treeOpen, setTreeOpen]           = useState(new Set());  // folderIds currently expanded
  const [treeChildren, setTreeChildren]   = useState({});         // folderId -> [{id,name}] (lazy-loaded)
  const [treeLoading, setTreeLoading]     = useState(new Set());  // folderIds currently fetching
  const [sharedDrivesOpen, setSharedDrivesOpen] = useState(true); // "Shared drives" section collapse

  const authHeader = useCallback(() => {
    const token = localStorage.getItem('token');
    return { Authorization: `Bearer ${token}` };
  }, []);

  // Connection check
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/google/status`, { headers: authHeader() });
        const data = await res.json();
        if (!cancelled) setConnected(!!data.connected);
      } catch (err) {
        if (!cancelled) setConnected(false);
      }
    })();
    return () => { cancelled = true; };
  }, [authHeader]);

  // Fetch shared drives once connected
  useEffect(() => {
    if (connected !== true) return;
    let cancelled = false;
    setDrivesLoading(true);
    (async () => {
      try {
        const res = await fetch(`${API_URL}/google/drive/drives`, { headers: authHeader() });
        const data = await res.json();
        if (cancelled) return;
        setDrives(res.ok ? (data.drives || []) : []);
      } catch (err) {
        if (!cancelled) setDrives([]);
      } finally {
        if (!cancelled) setDrivesLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [connected, authHeader]);

  // Fetch files when the current view (folder or drive) changes.
  // Skipped when a search is active — the search useEffect owns the file list then.
  useEffect(() => {
    if (connected !== true) return;
    if (searchQuery) return;  // search useEffect handles the list
    if (view.type === 'shared-with-me') {
      // Not implemented in D2 — placeholder list, treated as empty for now
      setFiles([]);
      setFilesLoading(false);
      setFilesError(null);
      return;
    }
    let cancelled = false;
    setFilesLoading(true);
    setFilesError(null);
    setSelectedFileId(null);

    const params = new URLSearchParams();
    params.set('folderId', view.folderId || 'root');
    if (view.driveId) params.set('driveId', view.driveId);

    (async () => {
      try {
        const res = await fetch(`${API_URL}/google/drive/files?${params}`, { headers: authHeader() });
        const data = await res.json();
        if (cancelled) return;
        if (!res.ok) {
          setFilesError(data.error || 'Failed to load files');
          setFiles([]);
        } else {
          setFiles(data.files || []);
        }
      } catch (err) {
        if (!cancelled) {
          setFilesError('Network error');
          setFiles([]);
        }
      } finally {
        if (!cancelled) setFilesLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [connected, view, searchQuery, authHeader]);

  // Refetch the current view's files (used after rename/delete to keep the list fresh)
  const refetchFiles = useCallback(async () => {
    if (connected !== true) return;
    if (view.type === 'shared-with-me') return;
    const params = new URLSearchParams();
    params.set('folderId', view.folderId || 'root');
    if (view.driveId) params.set('driveId', view.driveId);
    try {
      const res = await fetch(`${API_URL}/google/drive/files?${params}`, { headers: authHeader() });
      const data = await res.json();
      if (res.ok) setFiles(data.files || []);
    } catch (err) {
      // Non-fatal — silent refresh, list will retry on next user action
    }
  }, [connected, view, authHeader]);

  // Open in new tab
  const handleOpen = (file) => {
    setMenuOpenForId(null);
    if (file.webViewLink) {
      window.open(file.webViewLink, '_blank', 'noopener,noreferrer');
    }
  };

  // Download — backend streams the file (or exports Google formats to a downloadable format)
  const handleDownload = (file) => {
    setMenuOpenForId(null);
    const token = localStorage.getItem('token');
    // We can't add an Authorization header to window.open, so use a fetch + blob URL.
    (async () => {
      try {
        const res = await fetch(`${API_URL}/google/drive/files/${file.id}/download`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!res.ok) throw new Error('Download failed');
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error('Download error:', err);
      }
    })();
  };

  // Delete — move to Drive trash, then refetch
  const handleDelete = async (file) => {
    setMenuOpenForId(null);
    try {
      await fetch(`${API_URL}/google/drive/files/${file.id}`, {
        method: 'DELETE',
        headers: authHeader()
      });
      // Optimistic local removal + refetch to be safe
      setFiles(prev => prev.filter(f => f.id !== file.id));
      if (selectedFileId === file.id) setSelectedFileId(null);
    } catch (err) {
      console.error('Delete error:', err);
      // If it failed, refetch to restore truth
      refetchFiles();
    }
  };

  // Open the rename modal
  const handleRenameOpen = (file) => {
    setMenuOpenForId(null);
    setRenameTarget({ id: file.id, name: file.name });
    setRenameValue(file.name);
  };

  // Submit the rename
  const submitRename = async (e) => {
    if (e) e.preventDefault();
    if (!renameTarget || renameBusy) return;
    const newName = renameValue.trim();
    if (!newName || newName === renameTarget.name) {
      setRenameTarget(null);
      return;
    }
    setRenameBusy(true);
    try {
      const res = await fetch(`${API_URL}/google/drive/files/${renameTarget.id}`, {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: newName })
      });
      if (res.ok) {
        // Update local file list with the new name
        setFiles(prev => prev.map(f => f.id === renameTarget.id ? { ...f, name: newName } : f));
      }
    } catch (err) {
      console.error('Rename error:', err);
    } finally {
      setRenameBusy(false);
      setRenameTarget(null);
    }
  };

  // Create a new folder in the current location
  const submitNewFolder = async (e) => {
    if (e) e.preventDefault();
    if (newFolderBusy) return;
    const trimmed = newFolderName.trim();
    if (!trimmed) {
      setNewFolderOpen(false);
      return;
    }
    setNewFolderBusy(true);
    try {
      const body = {
        name: trimmed,
        parentId: view.folderId || 'root'
      };
      if (view.driveId) body.driveId = view.driveId;
      const res = await fetch(`${API_URL}/google/drive/folder`, {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (res.ok) {
        await refetchFiles();
      }
    } catch (err) {
      console.error('New folder error:', err);
    } finally {
      setNewFolderBusy(false);
      setNewFolderOpen(false);
      setNewFolderName('');
    }
  };

  // Read a File as base64 (strips the data URL prefix)
  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      // result looks like "data:<mime>;base64,<...>"
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

  // Upload one or more File objects to the current folder
  const uploadFiles = async (fileList) => {
    const files = Array.from(fileList || []);
    if (files.length === 0) return;
    const total = files.length;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      setUploadProgress({ current: i + 1, total, filename: file.name });
      try {
        const content = await fileToBase64(file);
        const body = {
          name: file.name,
          mimeType: file.type || 'application/octet-stream',
          content,
          folderId: view.folderId || 'root'
        };
        if (view.driveId) body.driveId = view.driveId;
        const res = await fetch(`${API_URL}/google/drive/upload`, {
          method: 'POST',
          headers: { ...authHeader(), 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) {
          console.error(`Upload failed for ${file.name}`);
        }
      } catch (err) {
        console.error(`Upload error for ${file.name}:`, err);
      }
    }
    setUploadProgress(null);
    await refetchFiles();
  };

  // Hidden file input — triggered by clicking "Upload file" in the New menu
  const fileInputRef = React.useRef(null);
  const handleUploadClick = () => {
    setNewMenuOpen(false);
    if (fileInputRef.current) fileInputRef.current.click();
  };
  const onFileInputChange = (e) => {
    uploadFiles(e.target.files);
    e.target.value = ''; // allow re-uploading the same file later
  };

  // Drag-and-drop handlers for the file list area
  const onDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };
  const onDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Only deactivate when leaving the actual container, not crossing child elements
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDragActive(false);
  };
  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer && e.dataTransfer.files) {
      uploadFiles(e.dataTransfer.files);
    }
  };

  // Close kebab menu when clicking outside
  useEffect(() => {
    if (!menuOpenForId) return;
    const onDocClick = () => setMenuOpenForId(null);
    // Defer attachment by a microtask so the click that opened the menu doesn't close it
    const t = setTimeout(() => document.addEventListener('click', onDocClick), 0);
    return () => {
      clearTimeout(t);
      document.removeEventListener('click', onDocClick);
    };
  }, [menuOpenForId]);

  // Close the New menu when clicking outside
  useEffect(() => {
    if (!newMenuOpen) return;
    const onDocClick = () => setNewMenuOpen(false);
    const t = setTimeout(() => document.addEventListener('click', onDocClick), 0);
    return () => {
      clearTimeout(t);
      document.removeEventListener('click', onDocClick);
    };
  }, [newMenuOpen]);

  // When a search query is active, override the normal folder fetch with a search fetch.
  useEffect(() => {
    if (connected !== true) return;
    if (!searchQuery) return;  // no search active — normal folder fetch handles things
    let cancelled = false;
    setFilesLoading(true);
    setFilesError(null);
    setSelectedFileId(null);
    (async () => {
      try {
        const res = await fetch(
          `${API_URL}/google/drive/search?q=${encodeURIComponent(searchQuery)}`,
          { headers: authHeader() }
        );
        const data = await res.json();
        if (cancelled) return;
        if (!res.ok) {
          setFilesError(data.error || 'Search failed');
          setFiles([]);
        } else {
          // Rank results: exact filename match > word match > prefix match > substring match
          const q = searchQuery.toLowerCase();
          const wordBoundary = new RegExp('(^|[^a-z0-9])' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-z0-9]|$)', 'i');
          const ranked = (data.files || []).map(f => {
            const name = (f.name || '').toLowerCase();
            const nameNoExt = name.replace(/\.[^.]+$/, '');
            let score;
            if (nameNoExt === q || name === q) score = 0;            // exact
            else if (wordBoundary.test(name))  score = 1;            // word match
            else if (name.startsWith(q))       score = 2;            // prefix
            else                               score = 3;            // substring
            return { f, score };
          });
          ranked.sort((a, b) => a.score - b.score || a.f.name.localeCompare(b.f.name));
          setFiles(ranked.map(r => r.f));
        }
      } catch (err) {
        if (!cancelled) {
          setFilesError('Network error');
          setFiles([]);
        }
      } finally {
        if (!cancelled) setFilesLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [connected, searchQuery, authHeader]);

  // Submit search — commit the draft to active search query
  const submitSearch = (e) => {
    if (e) e.preventDefault();
    const v = searchDraft.trim();
    setSearchQuery(v);
  };

  // Clear search — back to normal folder view
  const clearSearch = () => {
    setSearchDraft('');
    setSearchQuery('');
  };

  // Navigate into a folder — push new breadcrumb and update view
  const enterFolder = (folder) => {
    setCrumbs(prev => [...prev, { id: folder.id, name: folder.name }]);
    setView(v => ({ ...v, folderId: folder.id }));
  };

  // Click a breadcrumb to jump back to that level
  const jumpToCrumb = (index) => {
    if (index === crumbs.length - 1) return; // already there
    const newCrumbs = crumbs.slice(0, index + 1);
    setCrumbs(newCrumbs);
    setView(v => ({ ...v, folderId: newCrumbs[newCrumbs.length - 1].id }));
  };

  // Reset breadcrumbs + view when switching the left-pane selection (My Drive / Shared with me / a shared drive)
  const switchTo = (type, driveId = null, driveName = null) => {
    setSelectedFileId(null);
    if (type === 'my-drive') {
      setCrumbs([{ id: 'root', name: 'My Drive' }]);
      setView({ type: 'my-drive', folderId: 'root', driveId: null });
    } else if (type === 'shared-with-me') {
      setCrumbs([{ id: 'shared', name: 'Shared with me' }]);
      setView({ type: 'shared-with-me', folderId: null, driveId: null });
    } else if (type === 'shared-drive') {
      setCrumbs([{ id: driveId, name: driveName }]);
      setView({ type: 'shared-drive', folderId: driveId, driveId: driveId });
    }
  };

  // ===== Sidebar folder tree =====
  const FOLDER_MIME = 'application/vnd.google-apps.folder';

  // Fetch just the subfolders of a folder (for the sidebar tree).
  const fetchSubfolders = useCallback(async (folderId, driveId) => {
    const params = new URLSearchParams();
    params.set('folderId', folderId);
    if (driveId) params.set('driveId', driveId);
    try {
      const res = await fetch(`${API_URL}/google/drive/files?${params}`, { headers: authHeader() });
      const data = await res.json();
      const list = res.ok ? (data.files || []) : [];
      return list.filter(f => f.mimeType === FOLDER_MIME).map(f => ({ id: f.id, name: f.name }));
    } catch (err) {
      return [];
    }
  }, [authHeader]);

  // Expand/collapse a node; lazy-load its subfolders the first time it's opened.
  const toggleTreeNode = async (folderId, driveId) => {
    const isOpen = treeOpen.has(folderId);
    setTreeOpen(prev => { const n = new Set(prev); if (isOpen) n.delete(folderId); else n.add(folderId); return n; });
    if (!isOpen && treeChildren[folderId] === undefined) {
      setTreeLoading(prev => new Set(prev).add(folderId));
      const kids = await fetchSubfolders(folderId, driveId);
      setTreeChildren(prev => ({ ...prev, [folderId]: kids }));
      setTreeLoading(prev => { const n = new Set(prev); n.delete(folderId); return n; });
    }
  };

  // Navigate the main list to a folder chosen in the tree (full breadcrumb path is known).
  const goToTreeFolder = (viewType, driveId, folderId, path) => {
    setSelectedFileId(null);
    setSearchQuery(''); setSearchDraft('');
    setCrumbs(path);
    setView({ type: viewType, folderId, driveId: driveId || null });
  };

  // A single tree row: [chevron toggle] [icon + name (navigates)]. Indented by depth.
  const renderTreeRow = ({ id, name, driveId, viewType, path, depth, active, icon }) => {
    const open = treeOpen.has(id);
    return (
      <div style={{ ...styles.treeRow, paddingLeft: 8 + depth * 14, ...(active ? styles.navItemActive : {}) }}>
        <button onClick={() => toggleTreeNode(id, driveId)} style={styles.treeChevron} aria-label={open ? 'Collapse' : 'Expand'} title={open ? 'Collapse' : 'Expand'}>
          <span style={{ display: 'inline-flex', transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 0.12s' }}><IconChevRight /></span>
        </button>
        <button onClick={() => goToTreeFolder(viewType, driveId, id, path)} style={styles.treeLabelBtn} title={name}>
          <span style={styles.navIcon}>{icon || <IconFolder />}</span>
          <span style={styles.navLabel}>{name}</span>
        </button>
      </div>
    );
  };

  // Render the expanded children (and their subtrees) of a node.
  const renderSubtree = (folderId, driveId, viewType, path, depth) => {
    if (!treeOpen.has(folderId)) return null;
    const kids = treeChildren[folderId];
    if (treeLoading.has(folderId) && kids === undefined) {
      return <div style={{ ...styles.muted, padding: '4px 12px', paddingLeft: 8 + depth * 14 + 22 }}>Loading…</div>;
    }
    if (kids && kids.length === 0) {
      return <div style={{ ...styles.muted, padding: '4px 12px', paddingLeft: 8 + depth * 14 + 22 }}>No folders</div>;
    }
    return (kids || []).map(child => {
      const childPath = [...path, { id: child.id, name: child.name }];
      const active = view.folderId === child.id;
      return (
        <div key={child.id}>
          {renderTreeRow({ id: child.id, name: child.name, driveId, viewType, path: childPath, depth, active })}
          {renderSubtree(child.id, driveId, viewType, childPath, depth + 1)}
        </div>
      );
    });
  };

  // Connect Drive (same OAuth flow as Gmail — same tokens cover both)
  const handleConnect = async () => {
    try {
      const res = await fetch(`${API_URL}/google/auth`, { headers: authHeader() });
      const data = await res.json();
      if (!data.url) return;
      const popup = window.open(data.url, 'drive_connect', 'width=520,height=640');
      const onMessage = (event) => {
        if (event.data && event.data.type === 'GMAIL_CONNECTED') {
          setConnected(true);
          window.removeEventListener('message', onMessage);
          if (popup && !popup.closed) popup.close();
        }
      };
      window.addEventListener('message', onMessage);
    } catch (err) {
      console.error('Drive connect error:', err);
    }
  };

  // ===== Render states =====

  if (connected === null) {
    return (
      <div style={styles.centered}>
        <div style={styles.muted}>Checking Drive connection…</div>
      </div>
    );
  }

  if (connected === false) {
    return (
      <div style={styles.centered}>
        <h2 style={{ margin: '0 0 8px 0', fontSize: 18, fontWeight: 500 }}>Connect Google Drive</h2>
        <p style={{ ...styles.muted, marginBottom: 16, maxWidth: 360, textAlign: 'center' }}>
          Sign in with your CAAM Google account to browse your files and shared drives.
        </p>
        <button style={styles.primaryBtn} onClick={handleConnect}>
          Connect Drive
        </button>
      </div>
    );
  }

  const isActive = (predicate) => predicate ? styles.navItemActive : {};

  return (
    <div style={styles.shell}>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        style={{ display: 'none' }}
        onChange={onFileInputChange}
      />

      {/* Left: nav */}
      <aside style={styles.navPane}>
        <div style={{ position: 'relative', margin: '0 8px 16px 8px' }}>
          <button
            style={{ ...styles.newBtn, margin: 0, width: '100%' }}
            onClick={(e) => {
              e.stopPropagation();
              setNewMenuOpen(v => !v);
            }}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 8 }}><IconPlus /></span>
            New
          </button>
          {newMenuOpen && (
            <div style={styles.newMenu} onClick={(e) => e.stopPropagation()}>
              <button
                style={styles.newMenuItem}
                onClick={() => { setNewMenuOpen(false); setNewFolderOpen(true); setNewFolderName(''); }}
              >
                <span style={styles.newMenuIcon}><IconFolderPlus /></span>
                New folder
              </button>
              <button
                style={styles.newMenuItem}
                onClick={handleUploadClick}
              >
                <span style={styles.newMenuIcon}><IconUpload /></span>
                Upload file
              </button>
            </div>
          )}
        </div>

        <nav style={styles.navList}>
          {/* My Drive — expandable folder tree */}
          {renderTreeRow({
            id: 'root', name: 'My Drive', driveId: null, viewType: 'my-drive',
            path: [{ id: 'root', name: 'My Drive' }], depth: 0,
            active: view.type === 'my-drive' && view.folderId === 'root',
            icon: <IconHardDrive />
          })}
          {renderSubtree('root', null, 'my-drive', [{ id: 'root', name: 'My Drive' }], 1)}

          {/* Shared with me — flat destination */}
          <button
            onClick={() => switchTo('shared-with-me')}
            style={{ ...styles.navItem, ...isActive(view.type === 'shared-with-me') }}
          >
            <span style={styles.navIcon}><IconUsers /></span>
            <span>Shared with me</span>
          </button>
        </nav>

        {/* Shared drives — collapsible section, each drive its own expandable tree */}
        <button
          onClick={() => setSharedDrivesOpen(v => !v)}
          style={{ ...styles.navHeading, background: 'transparent', border: 'none', cursor: 'pointer', width: '100%' }}
        >
          <span style={{ display: 'inline-flex', marginRight: 4, transform: sharedDrivesOpen ? 'rotate(90deg)' : 'none', transition: 'transform 0.12s' }}><IconChevRight /></span>
          <span style={styles.navIcon}><IconShare /></span>
          Shared drives
        </button>
        {sharedDrivesOpen && (
          <nav style={styles.navList}>
            {drivesLoading && drives.length === 0 && (
              <div style={{ ...styles.muted, padding: '6px 12px' }}>Loading…</div>
            )}
            {!drivesLoading && drives.length === 0 && (
              <div style={{ ...styles.muted, padding: '6px 12px' }}>No shared drives</div>
            )}
            {drives.map(d => (
              <div key={d.id}>
                {renderTreeRow({
                  id: d.id, name: d.name, driveId: d.id, viewType: 'shared-drive',
                  path: [{ id: d.id, name: d.name }], depth: 0,
                  active: view.type === 'shared-drive' && view.driveId === d.id && view.folderId === d.id,
                  icon: <span style={{ ...styles.driveDot, background: d.colorRgb || 'var(--caam-text-muted)' }} />
                })}
                {renderSubtree(d.id, d.id, 'shared-drive', [{ id: d.id, name: d.name }], 1)}
              </div>
            ))}
          </nav>
        )}
      </aside>

      {/* Middle: file list */}
      <section style={styles.listPane}>
        <form onSubmit={submitSearch} style={styles.searchBar}>
          <span style={styles.searchIcon}><IconSearch /></span>
          <input
            type="text"
            placeholder="Search Drive"
            value={searchDraft}
            onChange={(e) => setSearchDraft(e.target.value)}
            style={styles.searchInput}
          />
          {(searchQuery || searchDraft) && (
            <button
              type="button"
              onClick={clearSearch}
              style={styles.searchClear}
              aria-label="Clear search"
            >
              <IconCloseSm />
            </button>
          )}
        </form>
        {searchQuery ? (
          <header style={styles.searchResultsBar}>
            Showing results for <strong>{searchQuery}</strong>
          </header>
        ) : (
          <header style={styles.crumbBar}>
          {crumbs.map((c, i) => (
            <React.Fragment key={c.id + ':' + i}>
              {i > 0 && <span style={styles.crumbSep}><IconChevRight /></span>}
              <button
                onClick={() => jumpToCrumb(i)}
                style={{
                  ...styles.crumbBtn,
                  ...(i === crumbs.length - 1 ? styles.crumbBtnActive : {})
                }}
                title={c.name}
              >
                {c.name}
              </button>
            </React.Fragment>
          ))}
          </header>
        )}
        <div
          style={{ ...styles.listScroller, position: 'relative' }}
          onDragEnter={onDragEnter}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
        >
          {dragActive && (
            <div style={styles.dropOverlay}>
              <div style={styles.dropOverlayText}>Drop files to upload</div>
            </div>
          )}
          {filesLoading && (
            <div style={{ ...styles.muted, padding: 16 }}>Loading…</div>
          )}
          {!filesLoading && filesError && (
            <div style={{ padding: 16, color: '#9B3A1F', fontSize: 13 }}>{filesError}</div>
          )}
          {!filesLoading && !filesError && view.type === 'shared-with-me' && (
            <div style={{ ...styles.muted, padding: 16 }}>
              Shared with me listing coming in a later stage.
            </div>
          )}
          {!filesLoading && !filesError && view.type !== 'shared-with-me' && files.length === 0 && (
            <div style={{ ...styles.muted, padding: 16 }}>This folder is empty.</div>
          )}
          {!filesLoading && !filesError && files.map(f => {
            const isFolder = f.mimeType === 'application/vnd.google-apps.folder';
            const isSelected = selectedFileId === f.id;
            return (
              <div
                key={f.id}
                onClick={() => {
                  if (isFolder) {
                    enterFolder(f);
                  } else {
                    setSelectedFileId(f.id);
                  }
                }}
                style={{
                  ...styles.fileRow,
                  ...(isSelected ? styles.fileRowSelected : {})
                }}
                className="drive-file-row"
              >
                <span style={styles.fileIcon}>{fileTypeIcon(f.mimeType)}</span>
                <span style={styles.fileName} title={f.name}>{f.name}</span>
                <span style={styles.fileOwner} title={fileOwner(f)}>{fileOwner(f)}</span>
                <span style={styles.fileDate}>{formatFileDate(f.modifiedTime)}</span>
                <span style={styles.fileSize}>{isFolder ? '—' : formatBytes(f.size)}</span>
                <span style={styles.fileKebabCell}>
                  <button
                    style={styles.kebabBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      setMenuOpenForId(menuOpenForId === f.id ? null : f.id);
                    }}
                    aria-label="File actions"
                  >
                    <IconKebab />
                  </button>
                  {menuOpenForId === f.id && (
                    <div style={styles.kebabMenu} onClick={(e) => e.stopPropagation()}>
                      {!isFolder && (
                        <button style={styles.kebabItem} onClick={() => handleOpen(f)}>
                          <span style={styles.kebabIcon}><IconExternal /></span>
                          Open in new tab
                        </button>
                      )}
                      {!isFolder && (
                        <button style={styles.kebabItem} onClick={() => handleDownload(f)}>
                          <span style={styles.kebabIcon}><IconDownload /></span>
                          Download
                        </button>
                      )}
                      <button style={styles.kebabItem} onClick={() => handleRenameOpen(f)}>
                        <span style={styles.kebabIcon}><IconEdit /></span>
                        Rename
                      </button>
                      <button style={{ ...styles.kebabItem, color: '#9B3A1F' }} onClick={() => handleDelete(f)}>
                        <span style={styles.kebabIcon}><IconTrash /></span>
                        Delete
                      </button>
                    </div>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </section>

      {uploadProgress && (
        <div style={styles.uploadToast}>
          Uploading {uploadProgress.filename} ({uploadProgress.current} of {uploadProgress.total})
        </div>
      )}

      {newFolderOpen && (
        <div style={styles.modalOverlay} onClick={() => !newFolderBusy && setNewFolderOpen(false)}>
          <form
            onSubmit={submitNewFolder}
            style={styles.renameCard}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={styles.renameTitle}>New folder</div>
            <input
              type="text"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
              placeholder="Untitled folder"
              style={styles.renameInput}
              autoFocus
              disabled={newFolderBusy}
            />
            <div style={styles.renameFooter}>
              <button
                type="button"
                style={styles.renameCancel}
                onClick={() => setNewFolderOpen(false)}
                disabled={newFolderBusy}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={styles.renameSubmit}
                disabled={newFolderBusy}
              >
                {newFolderBusy ? 'Creating…' : 'Create'}
              </button>
            </div>
          </form>
        </div>
      )}

      {renameTarget && (
        <div style={styles.modalOverlay} onClick={() => !renameBusy && setRenameTarget(null)}>
          <form
            onSubmit={submitRename}
            style={styles.renameCard}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={styles.renameTitle}>Rename</div>
            <input
              type="text"
              value={renameValue}
              onChange={(e) => setRenameValue(e.target.value)}
              style={styles.renameInput}
              autoFocus
              disabled={renameBusy}
            />
            <div style={styles.renameFooter}>
              <button
                type="button"
                style={styles.renameCancel}
                onClick={() => setRenameTarget(null)}
                disabled={renameBusy}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={styles.renameSubmit}
                disabled={renameBusy}
              >
                {renameBusy ? 'Saving…' : 'OK'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Right: preview pane */}
      <section style={styles.previewPane}>
        {(() => {
          const selected = selectedFileId
            ? files.find(f => f.id === selectedFileId)
            : null;

          if (!selected) {
            return (
              <div style={{ ...styles.muted, padding: 40, textAlign: 'center' }}>
                Select a file to preview.
              </div>
            );
          }

          const previewable = isInlinePreviewable(selected.mimeType);

          return (
            <>
              <header style={styles.previewHeader}>
                <div style={styles.previewTitle} title={selected.name}>{selected.name}</div>
                <div style={styles.previewMeta}>
                  <span>{mimeLabel(selected.mimeType)}</span>
                  {selected.modifiedTime && (
                    <>
                      <span style={styles.previewDot}>•</span>
                      <span>Modified {formatFileDate(selected.modifiedTime)}</span>
                    </>
                  )}
                  {fileOwner(selected) && (
                    <>
                      <span style={styles.previewDot}>•</span>
                      <span>{fileOwner(selected)}</span>
                    </>
                  )}
                </div>
                <div style={styles.previewActions}>
                  <a
                    href={selected.webViewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.openInDriveBtn}
                  >
                    <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 6 }}>
                      <IconExternal />
                    </span>
                    Open in Google Drive
                  </a>
                </div>
              </header>

              {previewable ? (
                <iframe
                  key={selected.id}
                  title={selected.name}
                  src={`https://drive.google.com/file/d/${selected.id}/preview`}
                  style={styles.previewFrame}
                  allow="autoplay"
                />
              ) : (
                <div style={styles.previewFallback}>
                  <div style={styles.previewFallbackIcon}>{fileTypeIcon(selected.mimeType)}</div>
                  <div style={styles.previewFallbackTitle}>{selected.name}</div>
                  <div style={styles.previewFallbackSub}>
                    {mimeLabel(selected.mimeType)} — opens in Google Drive
                  </div>
                  <a
                    href={selected.webViewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.openInDriveBtnLarge}
                  >
                    <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 8 }}>
                      <IconExternal />
                    </span>
                    Open in Google Drive
                  </a>
                </div>
              )}
            </>
          );
        })()}
      </section>
    </div>
  );
}

// ===== Helpers =====

function fileTypeIcon(mime) {
  if (!mime) return <IconFile />;
  if (mime === 'application/vnd.google-apps.folder') return <IconFolder />;
  if (mime.startsWith('image/')) return <IconImage />;
  if (mime === 'application/vnd.google-apps.document'
      || mime === 'application/vnd.google-apps.spreadsheet'
      || mime === 'application/vnd.google-apps.presentation'
      || mime === 'application/pdf'
      || mime.startsWith('text/')) return <IconFileText />;
  return <IconFile />;
}

function fileOwner(f) {
  if (!f.owners || f.owners.length === 0) return '';
  const owner = f.owners[0];
  if (owner.me) return 'me';
  return owner.displayName || owner.emailAddress || '';
}

function formatFileDate(rawDate) {
  if (!rawDate) return '';
  const d = new Date(rawDate);
  if (isNaN(d.getTime())) return '';
  const now = new Date();
  const sameYear = d.getFullYear() === now.getFullYear();
  if (sameYear) {
    return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
  }
  return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
}

// Files Google can render inline in their /preview iframe.
// Native Google formats and Microsoft Office formats both work — they render
// read-only. Editing for any of these still requires opening in a new tab
// because Google blocks third-party iframe embedding of their editors.
function isInlinePreviewable(mime) {
  if (!mime) return false;
  // Native browser/Google formats
  if (mime === 'application/pdf') return true;
  if (mime.startsWith('image/')) return true;
  if (mime.startsWith('video/')) return true;
  if (mime.startsWith('audio/')) return true;
  if (mime.startsWith('text/')) return true;
  // Google native formats (read-only preview)
  if (mime === 'application/vnd.google-apps.document')     return true;
  if (mime === 'application/vnd.google-apps.spreadsheet')  return true;
  if (mime === 'application/vnd.google-apps.presentation') return true;
  if (mime === 'application/vnd.google-apps.drawing')      return true;
  // Microsoft Office formats stored in Drive
  if (mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return true; // .docx
  if (mime === 'application/msword')                                                       return true; // .doc
  if (mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')         return true; // .xlsx
  if (mime === 'application/vnd.ms-excel')                                                  return true; // .xls
  if (mime === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') return true; // .pptx
  if (mime === 'application/vnd.ms-powerpoint')                                             return true; // .ppt
  return false;
}

// Friendly label for a MIME type (used in the preview header)
function mimeLabel(mime) {
  if (!mime) return 'File';
  if (mime === 'application/vnd.google-apps.folder')        return 'Folder';
  if (mime === 'application/vnd.google-apps.document')      return 'Google Doc';
  if (mime === 'application/vnd.google-apps.spreadsheet')   return 'Google Sheet';
  if (mime === 'application/vnd.google-apps.presentation')  return 'Google Slides';
  if (mime === 'application/vnd.google-apps.form')          return 'Google Form';
  if (mime === 'application/vnd.google-apps.drawing')       return 'Google Drawing';
  if (mime === 'application/pdf')                           return 'PDF';
  if (mime.startsWith('image/'))                            return 'Image';
  if (mime.startsWith('video/'))                            return 'Video';
  if (mime.startsWith('audio/'))                            return 'Audio';
  if (mime.startsWith('text/'))                             return 'Text';
  return 'File';
}

function formatBytes(bytes) {
  if (bytes == null || bytes === '') return '';
  const n = Number(bytes);
  if (!isFinite(n)) return '';
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  if (n < 1024 * 1024 * 1024) return (n / 1024 / 1024).toFixed(1) + ' MB';
  return (n / 1024 / 1024 / 1024).toFixed(2) + ' GB';
}

// ===== Styles (matches Gmail.jsx Apple-aesthetic) =====

const styles = {
  centered: {
    height: '100%',
    minHeight: 400,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
    color: 'var(--caam-text)'
  },
  muted: { color: 'var(--caam-text-light)', fontSize: 13 },
  primaryBtn: {
    padding: '10px 20px',
    fontSize: 14,
    fontWeight: 500,
    background: 'var(--caam-accent)',
    color: 'white',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer'
  },
  shell: {
    display: 'flex',
    height: 'calc(100vh - 80px)',
    background: 'var(--caam-cream-deep)',
    borderRadius: 8,
    overflow: 'hidden',
    border: '1px solid var(--caam-border)'
  },
  navPane: {
    width: 220,
    flexShrink: 0,
    padding: '16px 8px',
    borderRight: '1px solid var(--caam-border)',
    background: 'var(--caam-cream-deep)',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto'
  },
  newBtn: {
    margin: '0 8px 16px 8px',
    padding: '10px 16px',
    fontSize: 14,
    fontWeight: 500,
    background: 'var(--caam-accent)',
    color: 'white',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  navList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    fontSize: 13,
    color: 'var(--caam-text-muted)',
    background: 'transparent',
    border: 'none',
    borderRadius: 6,
    textAlign: 'left',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box'
  },
  navItemActive: {
    background: 'var(--caam-accent-tint)',
    color: 'var(--caam-accent)',
    fontWeight: 500
  },
  navIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 10,
    width: 16,
    height: 16,
    flexShrink: 0
  },
  navLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  treeRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: 6,
    color: 'var(--caam-text-muted)'
  },
  treeChevron: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--caam-text-light)',
    padding: '6px 2px',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0
  },
  treeLabelBtn: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    padding: '8px 8px 8px 2px',
    fontSize: 13,
    color: 'inherit',
    background: 'transparent',
    border: 'none',
    textAlign: 'left',
    cursor: 'pointer'
  },
  navHeading: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 11,
    fontWeight: 500,
    color: 'var(--caam-text-light)',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    padding: '16px 12px 8px'
  },
  driveDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    display: 'inline-block'
  },
  listPane: {
    width: 540,
    flexShrink: 0,
    borderRight: '1px solid var(--caam-border)',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  crumbBar: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 14px',
    borderBottom: '1px solid var(--caam-border)',
    background: 'white',
    flexShrink: 0,
    gap: 2,
    overflowX: 'auto',
    whiteSpace: 'nowrap'
  },
  crumbBtn: {
    background: 'transparent',
    border: 'none',
    color: 'var(--caam-accent)',
    fontSize: 13,
    padding: '4px 8px',
    borderRadius: 4,
    cursor: 'pointer'
  },
  crumbBtnActive: {
    color: 'var(--caam-text)',
    cursor: 'default',
    fontWeight: 500
  },
  crumbSep: {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'var(--caam-text-light)'
  },
  listScroller: {
    flex: 1,
    overflowY: 'auto'
  },
  fileRow: {
    display: 'grid',
    gridTemplateColumns: '24px 1fr 100px 90px 70px 32px',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    padding: '8px 14px',
    background: 'transparent',
    border: 'none',
    borderBottom: '1px solid var(--caam-cream-deep)',
    cursor: 'pointer',
    color: 'var(--caam-text)',
    textAlign: 'left',
    boxSizing: 'border-box',
    position: 'relative'
  },
  fileKebabCell: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  kebabBtn: {
    background: 'transparent',
    border: 'none',
    padding: 4,
    borderRadius: 4,
    cursor: 'pointer',
    color: 'var(--caam-text-muted)',
    display: 'inline-flex',
    alignItems: 'center'
  },
  kebabMenu: {
    position: 'absolute',
    top: 28,
    right: 0,
    background: 'white',
    border: '1px solid var(--caam-border)',
    borderRadius: 6,
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    padding: 4,
    minWidth: 180,
    zIndex: 50,
    display: 'flex',
    flexDirection: 'column'
  },
  kebabItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    fontSize: 13,
    color: 'var(--caam-text)',
    background: 'transparent',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%'
  },
  kebabIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 10,
    width: 16,
    height: 16
  },
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  renameCard: {
    width: 420,
    maxWidth: '90vw',
    background: 'white',
    borderRadius: 8,
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
    padding: 18,
    display: 'flex',
    flexDirection: 'column'
  },
  renameTitle: {
    fontSize: 15,
    fontWeight: 500,
    color: 'var(--caam-text)',
    marginBottom: 12
  },
  renameInput: {
    height: 36,
    padding: '0 10px',
    fontSize: 14,
    border: '1px solid var(--caam-border)',
    borderRadius: 6,
    outline: 'none',
    marginBottom: 14,
    boxSizing: 'border-box'
  },
  renameFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8
  },
  renameCancel: {
    padding: '8px 16px',
    fontSize: 13,
    color: 'var(--caam-text-muted)',
    background: 'transparent',
    border: '1px solid var(--caam-border)',
    borderRadius: 6,
    cursor: 'pointer'
  },
  renameSubmit: {
    padding: '8px 18px',
    fontSize: 13,
    fontWeight: 500,
    color: 'white',
    background: 'var(--caam-accent)',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer'
  },
  newMenu: {
    position: 'absolute',
    top: 44,
    left: 0,
    background: 'white',
    border: '1px solid var(--caam-border)',
    borderRadius: 6,
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    padding: 4,
    minWidth: 180,
    zIndex: 50,
    display: 'flex',
    flexDirection: 'column'
  },
  newMenuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    fontSize: 13,
    color: 'var(--caam-text)',
    background: 'transparent',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%'
  },
  newMenuIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 10,
    width: 16,
    height: 16
  },
  dropOverlay: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(232, 240, 254, 0.85)',
    border: '2px dashed var(--caam-accent)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 20,
    pointerEvents: 'none'
  },
  dropOverlayText: {
    fontSize: 16,
    fontWeight: 500,
    color: 'var(--caam-accent)'
  },
  searchBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 14px',
    borderBottom: '1px solid var(--caam-border)',
    background: 'white',
    flexShrink: 0
  },
  searchIcon: {
    color: 'var(--caam-text-light)',
    display: 'inline-flex',
    alignItems: 'center'
  },
  searchInput: {
    flex: 1,
    height: 30,
    padding: '0 8px',
    fontSize: 13,
    border: 'none',
    background: 'transparent',
    outline: 'none',
    boxSizing: 'border-box',
    color: 'var(--caam-text)'
  },
  searchClear: {
    background: 'transparent',
    border: 'none',
    color: 'var(--caam-text-muted)',
    cursor: 'pointer',
    padding: 2,
    display: 'inline-flex',
    alignItems: 'center'
  },
  searchResultsBar: {
    padding: '8px 14px',
    borderBottom: '1px solid var(--caam-border)',
    background: 'var(--caam-cream-deep)',
    fontSize: 12,
    color: 'var(--caam-text-muted)',
    flexShrink: 0
  },
  uploadToast: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    background: 'var(--caam-text)',
    color: 'white',
    fontSize: 13,
    padding: '10px 16px',
    borderRadius: 6,
    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
    zIndex: 2000
  },
  fileRowSelected: {
    background: 'var(--caam-accent-tint)'
  },
  fileIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'var(--caam-text-muted)'
  },
  fileName: {
    fontSize: 13,
    color: 'var(--caam-text)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  fileOwner: {
    fontSize: 12,
    color: 'var(--caam-text-muted)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  fileDate: {
    fontSize: 12,
    color: 'var(--caam-text-muted)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  fileSize: {
    fontSize: 12,
    color: 'var(--caam-text-muted)',
    textAlign: 'right'
  },
  previewPane: {
    flex: 1,
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  previewHeader: {
    padding: '14px 20px',
    borderBottom: '1px solid var(--caam-border)',
    background: 'white',
    flexShrink: 0
  },
  previewTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: 'var(--caam-text)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginBottom: 4
  },
  previewMeta: {
    fontSize: 12,
    color: 'var(--caam-text-muted)',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginBottom: 10
  },
  previewDot: {
    color: 'var(--caam-text-light)'
  },
  previewActions: {
    display: 'flex',
    gap: 8
  },
  openInDriveBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 12px',
    fontSize: 13,
    color: 'var(--caam-accent)',
    background: 'white',
    border: '1px solid var(--caam-border)',
    borderRadius: 6,
    cursor: 'pointer',
    textDecoration: 'none'
  },
  openInDriveBtnLarge: {
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: 16,
    padding: '10px 20px',
    fontSize: 14,
    fontWeight: 500,
    color: 'white',
    background: 'var(--caam-accent)',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    textDecoration: 'none'
  },
  previewFrame: {
    flex: 1,
    width: '100%',
    border: 'none',
    background: 'var(--caam-cream-deep)'
  },
  previewFallback: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
    background: 'var(--caam-cream-deep)'
  },
  previewFallbackIcon: {
    color: 'var(--caam-text-muted)',
    marginBottom: 16,
    transform: 'scale(3)'
  },
  previewFallbackTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: 'var(--caam-text)',
    marginBottom: 6,
    textAlign: 'center',
    maxWidth: 360,
    wordBreak: 'break-word'
  },
  previewFallbackSub: {
    fontSize: 13,
    color: 'var(--caam-text-muted)'
  }
};
